// NINGUNA PETICIÓN PUEDE QUEDARSE ESPERANDO PARA SIEMPRE.
//
// El 08-08 el chat se quedó tres minutos en "Actualizando la comida..." con el campo
// bloqueado y sin más salida que recargar; y recargando volvía a pasar, porque el que se
// colgaba entonces era el ARRANQUE. Cuando el backend acepta la conexión y luego no
// responde (se cae, se reinicia, la red se corta), un fetch sin `signal` no termina
// nunca: el `finally` que desbloquea la pantalla no llega, y da igual dónde esté escrito.
//
// Nació dentro de ChatbotPage y se trae aquí el 12-10 porque a "Terminar el día" de
// Nutrición le pasaba lo mismo (F3): una sola regla para las dos pantallas.
//
// 120 s es de sobra para lo más lento que hace el asistente, y sigue siendo mucho menos
// que "para siempre". El streaming del chat tiene su propio tope, y ese es al silencio.
export const TOPE_MS = 120000;

// LA CAMPANA SUELTA, para una operación que son VARIAS peticiones seguidas y tiene que
// acabar en un tiempo total (el cuadre del día encadena hasta ocho pasadas): la `signal`
// se pasa a cada petición y, cuando suena, la que esté en marcha se corta y las siguientes
// ya no salen. `apagar` va en el `finally` de quien la pide.
export const campanaDeTope = (ms = TOPE_MS) => {
    const ctrl = new AbortController();
    const campana = setTimeout(() => ctrl.abort(), ms);
    return { signal: ctrl.signal, apagar: () => clearTimeout(campana) };
};

export const fetchConTope = async (url, opciones = {}, ms = TOPE_MS) => {
    const { signal, apagar } = campanaDeTope(ms);
    try {
        return await fetch(url, { ...opciones, signal });
    } finally {
        apagar();
    }
};

// Si un error es de la campana (se cortó por tiempo) y no del servidor o de la red.
export const cortadoPorTope = (err) => err?.name === 'AbortError';

// PARA NO SEGUIR CON LO QUE YA SE CORTÓ. En una operación de varias peticiones, un `catch`
// de dentro puede tragarse el corte (o recibirlo disfrazado de otro error, si la campana
// suena mientras se lee una respuesta) y seguir con un resultado a medias. Antes de dar por
// bueno lo que haya, se mira la campana: si ya sonó, se lanza el mismo error que daría la
// petición cortada, el que reconoce `cortadoPorTope`.
export const pararSiSeCorto = (signal) => {
    if (!signal?.aborted) return;
    const corte = new Error('Cortado por tiempo');
    corte.name = 'AbortError';
    throw corte;
};
